import React, { useEffect, useState } from 'react'

export interface radioItem {
  // key: React.Key
  value: string
}
export type radioItemDict = { [key: string]: any }
export interface Props {
  radioItemDict: radioItemDict
  buttonStyle?: 'solid' | 'outline'
  defaultKey?: React.Key
  onChange?: (item: any) => void
}

export default function useHook(props: Props) {
  const { buttonStyle = 'solid', defaultKey, radioItemDict, onChange } = props
  const [currentKey, setCurrentKey] = useState(
    defaultKey ? defaultKey : Object.keys(radioItemDict)[0] || '',
  )
  const handleRadioChange = (key: any) => {
    setCurrentKey(key)
    onChange?.(key)
  }
  useEffect(() => {
    if (defaultKey) setCurrentKey(defaultKey)
  }, [defaultKey])
  return {
    buttonStyle,
    currentKey,
    radioItemDict,
    handleRadioChange,
  }
}
import React, { useEffect, useState } from 'react'

export interface radioItem {
  // key: React.Key
  value: string
}
export type radioItemDict = { [key: string]: any }
export interface Props {
  radioItemDict: radioItemDict
  buttonStyle?: 'solid' | 'outline'
  defaultKey?: React.Key
  onChange?: (item: any) => void
}

export default function useHook(props: Props) {
  const { buttonStyle = 'solid', defaultKey, radioItemDict, onChange } = props
  const [currentKey, setCurrentKey] = useState(
    defaultKey ? defaultKey : Object.keys(radioItemDict)[0] || '',
  )
  const handleRadioChange = (key: any) => {
    setCurrentKey(key)
    onChange?.(key)
  }
  useEffect(() => {
    if (defaultKey) setCurrentKey(defaultKey)
  }, [defaultKey])
  return {
    buttonStyle,
    currentKey,
    radioItemDict,
    handleRadioChange,
  }
}
